import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconExclamationCircle } from '@/assets/svgs/icon-exclamation-circle.svg';
import CardConfigure from "@/components/CardConfigure/index";
import Modal from "@/components/Modal/index";
import rem from '@/utils/rem';
import Button from '../Button/index';

const ModalTemplate = ({ visible, hide, icon, iconType = 'false', title, message, closable, leftFooterAction, rightFooterAction, rightFooterButtonText, addClass }) => {

    return (
        <Modal visible={visible} addClass={addClass}>
            <CardConfigure
                style={{ maxWidth: rem(500), position: 'relative' }}
                addHeaderClass="modal-template__header_divider"
            >
                <CardConfigure.Header>
                    <CardConfigure.Header.Icon type={iconType}>
                        <div className='modal-template__icon'>
                            {icon ?? <IconExclamationCircle />}
                        </div>
                    </CardConfigure.Header.Icon>
                    <CardConfigure.Header.Title>
                        {title || "-"}
                    </CardConfigure.Header.Title>
                    {closable && (
                        <CardConfigure.Header.Close onClick={() => hide()}>
                            <IconClose />
                        </CardConfigure.Header.Close>
                    )}
                </CardConfigure.Header>

                <CardConfigure.Body>
                    <CardConfigure.Body.Col>
                        <div>
                            {message ?? 'Error'}
                        </div>
                    </CardConfigure.Body.Col>
                </CardConfigure.Body>

                <CardConfigure.Footer>
                    <CardConfigure.Footer.Left>
                        {leftFooterAction ?? <></>}
                    </CardConfigure.Footer.Left>
                    <CardConfigure.Footer.Right>
                        {rightFooterAction ?? <Button data-testid="modal-template-confirm" full round maxWidth="100" submit={() => hide()} text={rightFooterButtonText || "Confirm"} />}
                    </CardConfigure.Footer.Right>
                </CardConfigure.Footer>
            </CardConfigure>
        </Modal>
    )
};

export default ModalTemplate;
